import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import LoginView from "../ux/login/LoginView.vue";

import { generalRoutes } from "@/router/generalRoutes";
import { isLoggedAlready } from "@/router/guards";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/login",
    name: "login",
    component: LoginView,
    beforeEnter: isLoggedAlready,
  },
];

const finalRoutes = [...generalRoutes, ...routes];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: finalRoutes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
      };
    }
  },
});

export default router;
